import React from 'react';
import __ from 'lodash';

class DropdownKelasParalel extends React.Component{
    render(){
        return (
            this.props.kelasParalel.map((val) => 
                <option key={val.idKelasParalel} value={val.idKelasParalel}>{val.namaKelasParalel}</option>
            )            
        )
    }
}

export default DropdownKelasParalel;